// extracted by mini-css-extract-plugin
module.exports = {"progress-bar":"progress-bar_progress-bar__IBYOF","progress-bar--completed":"progress-bar_progress-bar--completed__7n5uj"};